import React, { useState, useEffect } from 'react';

const CATEGORIES = ['Général','Travail','Personnel','Santé','Finances','Formation','Projet','Autre'];

export default function TaskModal({ task, onClose, onSubmit }) {
  const isEdit = !!task;
  const [form, setForm] = useState({ title:'', description:'', status:'todo', priority:'medium', category:'Général', dueDate:'', tags:'' });
  const [loading, setLoading] = useState(false);
  const [error, setError]   = useState('');

  useEffect(() => {
    if (task) setForm({
      title:       task.title || '',
      description: task.description || '',
      status:      task.status || 'todo',
      priority:    task.priority || 'medium',
      category:    task.category || 'Général',
      dueDate:     task.dueDate ? task.dueDate.split('T')[0] : '',
      tags:        task.tags?.join(', ') || ''
    });
  }, [task]);

  const set = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.title.trim()) return setError('Le titre est requis.');
    setLoading(true); setError('');
    try {
      await onSubmit({ ...form, tags: form.tags.split(',').map(t=>t.trim()).filter(Boolean), dueDate: form.dueDate || null });
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de la sauvegarde.');
    } finally { setLoading(false); }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">{isEdit ? '✏️ Modifier la tâche' : '✚ Nouvelle tâche'}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {error && <div className="alert alert-error">⚠️ {error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Titre *</label>
            <input className="form-input" name="title" value={form.title} onChange={set} placeholder="Nom de la tâche…" autoFocus required />
          </div>
          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea className="form-input" name="description" value={form.description} onChange={set} placeholder="Détails optionnels…" rows={3} />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Statut</label>
              <select className="form-input filter-select" name="status" value={form.status} onChange={set} style={{width:'100%'}}>
                <option value="todo">📋 À faire</option>
                <option value="in-progress">⚡ En cours</option>
                <option value="done">✅ Terminée</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Priorité</label>
              <select className="form-input filter-select" name="priority" value={form.priority} onChange={set} style={{width:'100%'}}>
                <option value="low">🟢 Faible</option>
                <option value="medium">🟡 Moyenne</option>
                <option value="high">🔴 Haute</option>
              </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Catégorie</label>
              <select className="form-input filter-select" name="category" value={form.category} onChange={set} style={{width:'100%'}}>
                {CATEGORIES.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Échéance</label>
              <input className="form-input" type="date" name="dueDate" value={form.dueDate} onChange={set} style={{colorScheme:'dark'}} />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Tags (virgule pour séparer)</label>
            <input className="form-input" name="tags" value={form.tags} onChange={set} placeholder="react, api, urgent…" />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-ghost" onClick={onClose}>Annuler</button>
            <button type="submit" className="btn btn-primary" disabled={loading} style={{width:'auto'}}>
              {loading ? '⏳ Sauvegarde…' : isEdit ? '✓ Enregistrer' : '✚ Créer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
